/**
 * 응답한 토큰값이 있는데 파라미터값 email과 값이 다르다면..에러 처리하자
 */
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { getTokenname } from 'utils'
import { validEmailShare } from 'ts-utils/survey'
import { SurveyLiveEmailContainer } from 'container'
import jwt from 'jsonwebtoken'
import { useLocation } from 'react-router-dom'
import queryString from 'query-string'
import { SHOW as ANSWERERRORPAGESHOW } from 'reducer/answerErrorPage'
import { useIntl } from 'react-intl'

function verify(token, email) {
    // 이메일 값이 형식(핸드폰 번호) 오류이면 조작된 메일주소로 들어오는거라 판단한다
    const valid = validEmailShare(email)
    if (!valid) return false

    // 토큰이 없다는거는 검증할 값이 없음이다.
    if (!token) return true
    
    try {
        const obj = JSON.parse(token)
        return obj.g === email
    } catch(e) {
        const obj = jwt.decode(token)
        return obj.email === email
    }
}


function VarificationEmailContainer(props) {
    const { survey_no } = props

    const dispatch = useDispatch()

    const location = useLocation()

    const { email } = queryString.parse(location.search)

    const tokenname = getTokenname(survey_no, 'email')

    const { formatMessage: f } = useIntl()

    const isVerify = verify( localStorage.getItem(tokenname), email )

    useEffect(() => {
        if (!isVerify) {
            dispatch({ type: ANSWERERRORPAGESHOW, message: f({id: 'container.Survey.Live.VarificationEmail.message'}), f, iconType: 'private'})
        }
    }, [isVerify, dispatch, f ])

    return (
        <>
        {
            isVerify && (
                <SurveyLiveEmailContainer {...props}/>
            )
        }
        </>
    )
}

export default VarificationEmailContainer